import React, { useState } from 'react';
import { BulkDeleteTimeslotsModalView, BulkDeleteTimeslotsModalViewProps } from './BulkDeleteTimeslotsModal.view';
import { SubmitHandler } from 'react-hook-form/dist/types/form';
import { BulkDeleteTimeslotsMutationFn } from '../../../../models/graphql';
import { GetTimeslots_workspace_timeslots } from '../../../../models/legacy-graphql';
import { FieldValues } from 'react-hook-form';
import { showToast } from '../../../../helpers/showToast';
import { remapApolloErrors } from '../../../../helpers/remapApolloErrors';
import { ApolloError } from '@apollo/client';

export type BulkDeleteTimeslotsModalControllerProps = Omit<
  BulkDeleteTimeslotsModalViewProps,
  'deleteTimeslotHandler' | 'submitted'
> & {
  bulkDeleteTimeslots: BulkDeleteTimeslotsMutationFn;
  timeslots: GetTimeslots_workspace_timeslots[];
};

export const BulkDeleteTimeslotsModalController = (props: BulkDeleteTimeslotsModalControllerProps): JSX.Element => {
  const [submitted, setSubmitted] = useState<boolean>(false);

  const deleteTimeslotHandler: SubmitHandler<FieldValues> = (_, ev) => {
    ev?.preventDefault();

    const timeslotIds: string[] = props.timeslots.map(t => t.id);

    props
      .bulkDeleteTimeslots({
        variables: { timeslotIds: timeslotIds },
        update: cache => {
          props.timeslots.forEach(t => {
            cache.evict({ id: cache.identify({ id: t.id, __typename: 'Timeslot' }) });
            cache.gc();
          });

          props.onClose();
        }
      })
      .catch((error: ApolloError) => {
        showToast({
          severity: 'error',
          summary: 'Timeslots not deleted. Please try again.',
          detail: remapApolloErrors(error as ApolloError)
        });

        props.onClose();
      });

    setSubmitted(true);
  };

  const viewProps: BulkDeleteTimeslotsModalViewProps = { ...props, submitted, deleteTimeslotHandler };
  return <BulkDeleteTimeslotsModalView {...viewProps} />;
};
